import { styled, Container as MuiContainer, Box, Typography, TypographyProps } from '@mui/material'

export const Container = styled(MuiContainer)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  maxWidth: '1440px',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 4),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 12),
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 23),
  },
  [theme.breakpoints.up('xl')]: {
    padding: theme.spacing(0, 20),
  },
}))

export const Title = styled((props) => <Typography component="h1" {...props}/>)<TypographyProps>(({ theme }) => ({
  ...theme.typography.h2,
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    ...theme.typography.displaySm,
  },
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.display,
  },
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle1,
  marginBottom: '-8px',
}))

export const Context = styled(Typography)({
  fontFamily: 'Roboto',
  fontSize: '16px',
  lineHeight: '24px',
  weight: '400',
})

export const Pills = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(6),
  [theme.breakpoints.only('lg')]: {
    marginBottom: theme.spacing(4),
  },
}))

export const Pill = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.surface['800'],
  borderRadius: theme.spacing(4),
  padding: theme.spacing(0.75, 1.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(1.5, 3),
  },
}))

export const PillText = styled(Typography)(({ theme }) => ({
  ...theme.typography.button2,
  fontWeight: 500,
}))

export const TechStacks = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  justifyContent: 'center',
  marginBottom: theme.spacing(9),
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(15),
  },
  [theme.breakpoints.up('lg')]: {
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(13),
  },
  [theme.breakpoints.up('xl')]: {
    marginBottom: theme.spacing(22),
  },
}))

export const Tech = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const TechLogo = styled(Box)(({ theme }) => ({
  width: 151,
  height: 151,
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    width: 160,
    height: 160,
  },
}))

export const TechName = styled(Typography)(({ theme }) => ({
  maxWidth: 151,
  fontFamily: 'GeneralSans, sans-serif',
  fontWeight: 500,
  fontSize: 20,
  lineHeight: '28px',
  marginTop: theme.spacing(3),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 160,
  },
}))
